module.exports = __webpack_public_path__ + "img/opcion-multiple.dac5f255.svg";